import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import moment from 'moment';
import Button from 'Components/Button';
import WhatsAppService from 'Services/Http/WhatsApp.service';
import ProgressBar from 'Components/ProgressBar';
import { formatCurrency, nameMonth } from 'Utils/Functions';
import ControllerSelect from 'Components/ControllerSelect';
import { useForm } from 'react-hook-form';
import { MonthSchema } from 'Services/yup/form';
import { yupResolver } from '@hookform/resolvers/yup';

const ListarMensajesCobroComponente = () => {
  const [otps, setOtps] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pageActive, setPageActive] = useState(0);
  const [numberMonth, setNumberMonth] = useState(null);
  const [precioUnitario, setPrecioUnitario] = useState(0);
  const [costoTotal, setCostoTotal] = useState(0);
  const [totalMensajes, setTotalMensajes] = useState(0);
  const [months, setMonths] = useState([]);
  useEffect(() => {
    getNumberMonth();
    getlastOtps();
    getMonths();
  }, []);

  const getNumberMonth = () => {
    const now = new Date();
    const month = now.getMonth();
    setNumberMonth(month + 1);
  };

  const getlastOtps = async (page) => {
    setLoader(true);
    setOtps([]);
    setPageActive(page);
    const month = numberMonth ?? null;
    const response = await WhatsAppService.getMessageCosto({ page, month });
    createRows(response.data.registros);
    setPrecioUnitario(response.data.precioUnidad);
    setCostoTotal(response.data.costo);
    setTotalMensajes(response.data.totalMensajes);
    setLoader(false);
  };

  const {
    control,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      month: ''
    },
    resolver: yupResolver(MonthSchema)
  });

  const valueSelect = watch('month');
  useEffect(() => {
    if (valueSelect !== '') {
      setNumberMonth(valueSelect);
    }
  }, [valueSelect]);

  useEffect(() => {
    getlastOtps();
  }, [numberMonth]);

  const replaceText = (text) => {
    let newText;
    switch (text) {
      case 'sent':
        newText = 'Enviado';
        break;
      case 'delivered':
        newText = 'Entregado';
        break;
      case 'read':
        newText = 'Leido';
        break;
      case 'failed':
        newText = 'Fallido';
        break;
      default:
        newText = text;
        break;
    }
    return newText;
  };

  const getMonths = async () => {
    const data = [];
    const ahora = moment();
    const anio = ahora.format('YYYY');
    const month = ahora.format('M');
    data.push({
      label: nameMonth(month) + ' ' + anio,
      value: month
    });
    for (let i = 1; i <= 2; i++) {
      const nuevaFecha = moment().subtract(i, 'months');
      const anioFecha = nuevaFecha.format('YYYY');
      const monthFecha = nuevaFecha.format('M');
      data.push({
        label: nameMonth(monthFecha) + ' ' + anioFecha,
        value: monthFecha
      });
    }
    setMonths(data);
  };
  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'otps-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{index + 1}</td>
        <td className="px-6 py-4">{item.id}</td>
        <td className="px-6 py-4">{item.telefono}</td>
        <td className="px-3 py-4 w-2/5" dangerouslySetInnerHTML={{ __html: item.text }}></td>
        <td className="px-6 py-4">{replaceText(item.status)}</td>
        <td className="px-6 py-4">${item.precio}</td>
        <td className="px-6 py-4">{item.error}</td>
        <td className="px-6 py-4">{moment(item.created_at).format('DD/MM/YYYY hh:mm:ss a')}</td>
      </tr>
    ));
    setOtps(data);
  };
  const refresh = () => {
    getlastOtps(pageActive);
  };
  return (
    <>
      <Label text={'Lista de Mensajes Cobro'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <Button iconprefix={['fa', 'rotate']} onClick={() => refresh()} />
        </div>
      </div>
      <div className="flex flex-col my-5 justify-stretch">
        <ControllerSelect
          data={months}
          control={control}
          name="month"
          error={errors?.month}
          label="Seleccionar un tipo de notificacion"
        />
      </div>
      <div className="flex flex-col my-5 justify-stretch">
        <div className="flex">
          Precio unitario del mensaje: <strong>${`${precioUnitario}`}</strong>
        </div>
        <div className="flex">
          Mensajes de cobro: <strong>{`${totalMensajes}`}</strong>
        </div>
        <div className="flex">
          Costo total: <strong>{formatCurrency(costoTotal || 0)} USD</strong>
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Id
              </th>
              <th scope="col" className="px-6 py-3">
                Numero mov&iacute;l
              </th>
              <th scope="col" className="px-6 py-3">
                Mensaje enviado
              </th>
              <th scope="col" className="px-6 py-3">
                Estatus
              </th>
              <th scope="col" className="px-6 py-3">
                Precio
              </th>
              <th scope="col" className="px-6 py-3">
                Error
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha y hora de env&iacute;o
              </th>
            </tr>
          </thead>
          <tbody>{otps}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarMensajesCobroComponente;
